import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SpecialistListComponent} from './specialist-list/specialist-list.component';
import {SpecialistViewComponent} from './specialist-view/specialist-view.component';
import {SpecialistFormComponent} from './specialist-form/specialist-form.component';
import {SpecialistsResolverService} from '@providers/_resolvers/specialists-resolver.service';
import {SpecialistResolverService} from './services/specialist-resolver.service';

export const specialistModuleRoutes: Routes = [
    { path: '', children: [
        { path: '', redirectTo: 'index', pathMatch: 'full' },
        { path: 'index',
            component: SpecialistListComponent,
            data: {title: 'Специалисты'},
            resolve: {
                specialists: SpecialistsResolverService,
            }
        },
        { path: 'view', redirectTo: 'index' },
        { path: 'view/:id',
            component: SpecialistViewComponent,
            data: {title: 'Просмотр специалиста'},
            resolve: {
                specialist: SpecialistResolverService,
            }
        },
        { path: 'form', redirectTo: 'new' },
        { path: 'new', component: SpecialistFormComponent, data: {title: 'Создание специалиста'} },
        { path: 'edit', redirectTo: 'index' },
        { path: 'edit/:id',
            component: SpecialistFormComponent,
            data: {title: 'Редактирование специалиста'},
            resolve: {
                specialist: SpecialistResolverService,
            },
        },
    ]},
];

@NgModule({
    imports: [
        RouterModule.forChild(specialistModuleRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class SpecialistRoutingModule {}
